/**
 * F14.3 — ForgotPassword refatorado para design system v2.1 + i18n.
 */

import { useState } from "react";
import {
  AlertError,
  AlertSuccess,
  AuthBrand,
  AuthShell,
  FieldLabel,
  GhostLink,
  PillInput,
  PrimaryButton,
} from "../components/auth/AuthShell.js";
import { useI18n, useT } from "../i18n/index.js";
import { trpc } from "../lib/trpc.js";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailFocused, setEmailFocused] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { locale } = useI18n();
  const t = useT();

  const requestMutation = trpc.passwordReset.request.useMutation({
    onSuccess: () => setSubmitted(true),
    onError: (err) => setError(err.message),
  });

  const pending = requestMutation.isPending;

  return (
    <AuthShell>
      <div className="w-full max-w-[430px]">
        <AuthBrand subtitle={t("auth.forgotTitle")} />

        {submitted ? (
          <div className="space-y-6">
            <AlertSuccess>{t("auth.forgotSent")}</AlertSuccess>
            <GhostLink href="/login">{t("auth.backToLoginLink")}</GhostLink>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setError(null);
              requestMutation.mutate({ email, lang: locale });
            }}
          >
            <p
              style={{
                fontFamily: "var(--font-body)",
                fontSize: 14,
                color: "var(--text-secondary)",
                textAlign: "center",
                marginBottom: 24,
                lineHeight: 1.5,
              }}
            >
              {t("auth.forgotDescription")}
            </p>

            <FieldLabel htmlFor="email">{t("auth.emailLabel")}</FieldLabel>
            <PillInput
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={setEmail}
              focused={emailFocused}
              onFocus={() => setEmailFocused(true)}
              onBlur={() => setEmailFocused(false)}
              disabled={pending}
              autoFocus
              placeholder={t("auth.emailPlaceholder")}
            />

            {error && (
              <div className="mt-5">
                <AlertError>{error}</AlertError>
              </div>
            )}

            <div className="mt-7">
              <PrimaryButton disabled={pending}>
                {pending ? t("auth.submitForgotPending") : t("auth.submitForgot")}
              </PrimaryButton>
            </div>

            <div className="mt-6">
              <GhostLink href="/login">{t("auth.backToLoginLink")}</GhostLink>
            </div>
          </form>
        )}
      </div>
    </AuthShell>
  );
}
